import { render, staticRenderFns } from "./TokamakFusionViz.vue?vue&type=template&id=1ba9ed14&scoped=true"
import script from "./TokamakFusionViz.vue?vue&type=script&lang=js"
export * from "./TokamakFusionViz.vue?vue&type=script&lang=js"
import style0 from "./TokamakFusionViz.vue?vue&type=style&index=0&id=1ba9ed14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9ed14",
  null
  
)

export default component.exports